(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('@angular/core'),require('@angular/platform-browser'),require('@angular/common'),exports, require('@angular/common'), require('@angular/core'), require('@angular/platform-browser'), require('rxjs'), require('rxjs/operators')) :
    typeof define === 'function' && define.amd ? define('@ngneat/hotkeys', ['@angular/core','@angular/platform-browser','@angular/common','exports', '@angular/common', '@angular/core', '@angular/platform-browser', 'rxjs', 'rxjs/operators'], factory) :
    (global = global || self, factory(global.ng.core,global.ng.platformBrowser,global.ng.common,(global.ngneat = global.ngneat || {}, global.ngneat.hotkeys = {}), global.ng.common, global.ng.core, global.ng.platformBrowser, global.rxjs, global.rxjs.operators));
}(this, (function (ɵngcc0,ɵngcc1,ɵngcc2,exports, common, core, platformBrowser, rxjs, operators) { 
function HotkeysHelpComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2)(1, "span", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 4);
    ɵngcc0.ɵɵlistener("click", function HotkeysHelpComponent_div_0_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r3); var ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.handleDismiss(); });
    ɵngcc0.ɵɵtext(4, "\u2715");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
} }
function HotkeysHelpComponent_table_1_thead_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "thead")(1, "tr")(2, "th", 8);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    var hotkeyGroup_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(hotkeyGroup_r4.group);
} }
function HotkeysHelpComponent_table_1_tr_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 9)(1, "td", 10);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td", 11);
    ɵngcc0.ɵɵelement(4, "kbd", 12);
    ɵngcc0.ɵɵpipe(5, "hotkeysShortcut");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    var hotkey_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(hotkey_r8.description);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(5, 2, hotkey_r8.keys), ɵngcc0.ɵɵsanitizeHtml);
} }
function HotkeysHelpComponent_table_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "table", 5);
    ɵngcc0.ɵɵtemplate(1, HotkeysHelpComponent_table_1_thead_1_Template, 4, 1, "thead", 6);
    ɵngcc0.ɵɵelementStart(2, "tbody");
    ɵngcc0.ɵɵtemplate(3, HotkeysHelpComponent_table_1_tr_3_Template, 6, 4, "tr", 7);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    var hotkeyGroup_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", hotkeyGroup_r4.group);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", hotkeyGroup_r4.hotkeys);
} }
'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    function hostPlatform() {
        var appleDevices = ['Mac', 'iPhone', 'iPad', 'iPhone'];
        return appleDevices.some(function (d) { return navigator.platform.includes(d); }) ? 'apple' : 'pc';
    }
    function normalizeKeys(keys, platform) {
        var lowercaseKeys = keys.toLowerCase();
        switch (platform) {
            case 'pc':
                return lowercaseKeys
                    .split('.')
                    .map(function (k) { return (k === 'meta' ? 'control' : k); })
                    .join('.');
            default:
                return keys;
        }
    }

    function coerceArray(params) {
        return Array.isArray(params) ? params : [params];
    }

    var HotkeysService = /** @class */ (function () {
        function HotkeysService(eventManager, document) {
            this.eventManager = eventManager;
            this.document = document;
            this.hotkeys = new Map();
            this.dispose = new rxjs.Subject();
            this.defaults = {
                trigger: 'keydown',
                allowIn: [],
                element: this.document.documentElement,
                group: undefined,
                description: undefined,
                showInHelpMenu: true,
                preventDefault: true
            };
            this.callbacks = [];
        }
        HotkeysService.prototype.getHotkeys = function () {
            return Array.from(this.hotkeys.values()).map(function (h) { return (__assign({}, h)); });
        };
        HotkeysService.prototype.getShortcuts = function () {
            var e_1, _a;
            var hotkeys = Array.from(this.hotkeys.values());
            var groups = [];
            var _loop_1 = function (hotkey) {
                if (!hotkey.showInHelpMenu) {
                    return "continue";
                }
                var group = groups.find(function (g) { return g.group === hotkey.group; });
                if (!group) {
                    group = { group: hotkey.group, hotkeys: [] };
                    groups.push(group);
                }
                var normalizedKeys = normalizeKeys(hotkey.keys, hostPlatform());
                group.hotkeys.push({ keys: normalizedKeys, description: hotkey.description });
            };
            try {
                for (var hotkeys_1 = __values(hotkeys), hotkeys_1_1 = hotkeys_1.next(); !hotkeys_1_1.done; hotkeys_1_1 = hotkeys_1.next()) {
                    var hotkey = hotkeys_1_1.value;
                    _loop_1(hotkey);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (hotkeys_1_1 && !hotkeys_1_1.done && (_a = hotkeys_1.return)) _a.call(hotkeys_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return groups;
        };
        HotkeysService.prototype.addShortcut = function (options) {
            var _this = this;
            var mergedOptions = __assign(__assign({}, this.defaults), options);
            var normalizedKeys = normalizeKeys(mergedOptions.keys, hostPlatform());
            if (this.hotkeys.has(normalizedKeys)) {
                console.error('Duplicated shortcut');
                return rxjs.of(null);
            }
            this.hotkeys.set(normalizedKeys, mergedOptions);
            var event = mergedOptions.trigger + "." + normalizedKeys;
            return new rxjs.Observable(function (observer) {
                var handler = function (e) {
                    var hotkey = _this.hotkeys.get(normalizedKeys);
                    var excludedTargets = _this.getExcludedTargets(hotkey.allowIn || []);
                    var skipShortcutTrigger = excludedTargets && excludedTargets.includes(document.activeElement.nodeName);
                    if (skipShortcutTrigger) {
                        return;
                    }
                    if (mergedOptions.preventDefault) {
                        e.preventDefault();
                    }
                    _this.callbacks.forEach(function (cb) { return cb(e, normalizedKeys, hotkey.element); });
                    observer.next(e);
                };
                var dispose = _this.eventManager.addEventListener(mergedOptions.element, event, handler);
                return function () {
                    _this.hotkeys.delete(normalizedKeys);
                    dispose();
                };
            }).pipe(operators.takeUntil(this.dispose.pipe(operators.filter(function (v) { return v === normalizedKeys; }))));
        };
        HotkeysService.prototype.removeShortcuts = function (hotkeys) {
            var _this = this;
            var coercedHotkeys = coerceArray(hotkeys).map(function (hotkey) { return normalizeKeys(hotkey, hostPlatform()); });
            coercedHotkeys.forEach(function (hotkey) {
                _this.hotkeys.delete(hotkey);
                _this.dispose.next(hotkey);
            });
        };
        HotkeysService.prototype.onShortcut = function (callback) {
            var _this = this;
            this.callbacks.push(callback);
            return function () { return (_this.callbacks = _this.callbacks.filter(function (cb) { return cb !== callback; })); };
        };
        HotkeysService.prototype.registerHelpModal = function (openHelpModalFn, helpShortcut) {
            var _this = this;
            if (helpShortcut === void 0) { helpShortcut = ''; }
            this.addShortcut({ keys: helpShortcut || 'shift.?', showInHelpMenu: false, preventDefault: false }).subscribe(function (e) {
                var skipMenu = /^(input|textarea|select)$/i.test(document.activeElement.nodeName) ||
                    e.target.isContentEditable;
                if (!skipMenu && _this.hotkeys.size) {
                    openHelpModalFn();
                }
            });
        };
        HotkeysService.prototype.getExcludedTargets = function (allowIn) {
            return ['INPUT', 'SELECT', 'TEXTAREA'].filter(function (t) { return !allowIn.includes(t); });
        };
        HotkeysService.ctorParameters = function () { return [
            { type: platformBrowser.EventManager },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] }] }
        ]; };
        HotkeysService.ɵprov = core["ɵɵdefineInjectable"]({ factory: function HotkeysService_Factory() { return new HotkeysService(core["ɵɵinject"](platformBrowser.EventManager), core["ɵɵinject"](common.DOCUMENT)); }, token: HotkeysService, providedIn: "root" });
        HotkeysService = __decorate([ __param(1, core.Inject(common.DOCUMENT))
        ], HotkeysService);
HotkeysService.ɵfac = function HotkeysService_Factory(t) { return new (t || HotkeysService)(ɵngcc0.ɵɵinject(ɵngcc1.EventManager), ɵngcc0.ɵɵinject(common.DOCUMENT)); };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotkeysService, [{
        type: core.Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.EventManager }, { type: undefined, decorators: [{
                type: core.Inject,
                args: [common.DOCUMENT]
            }] }]; }, null); })();
        return HotkeysService;
    }());

    var HotkeysDirective = /** @class */ (function () {
        function HotkeysDirective(hotkeysService, elementRef) {
            this.hotkeysService = hotkeysService;
            this.elementRef = elementRef;
            this.hotkeysOptions = {};
            this.hotkey = new core.EventEmitter();
        }
        HotkeysDirective.prototype.ngOnChanges = function (changes) {
            this.deleteHotkeys();
            if (!this.hotkeys) {
                return;
            }
            var hotkey = __assign({ keys: this.hotkeys, group: this.hotkeysGroup, description: this.hotkeysDescription }, this.hotkeysOptions);
            this.setHotkeys(hotkey);
        };
        HotkeysDirective.prototype.ngOnDestroy = function () {
            this.deleteHotkeys();
        };
        HotkeysDirective.prototype.deleteHotkeys = function () {
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
            this.subscription = null;
        };
        HotkeysDirective.prototype.setHotkeys = function (hotkeys) {
            var _this = this;
            var coercedHotkeys = coerceArray(hotkeys);
            this.subscription = rxjs.merge(coercedHotkeys.map(function (hotkey) {
                return _this.hotkeysService.addShortcut(__assign(__assign({}, hotkey), { element: _this.elementRef.nativeElement }));
            }))
                .pipe(operators.mergeAll())
                .subscribe(function (e) { return _this.hotkey.next(e); });
        };
        HotkeysDirective.ctorParameters = function () { return [
            { type: HotkeysService },
            { type: core.ElementRef }
        ]; };
        __decorate([
            core.Input()
        ], HotkeysDirective.prototype, "hotkeys", void 0);
        __decorate([
            core.Input()
        ], HotkeysDirective.prototype, "hotkeysGroup", void 0);
        __decorate([
            core.Input()
        ], HotkeysDirective.prototype, "hotkeysOptions", void 0);
        __decorate([
            core.Input()
        ], HotkeysDirective.prototype, "hotkeysDescription", void 0);
        __decorate([
            core.Output()
        ], HotkeysDirective.prototype, "hotkey", void 0);
HotkeysDirective.ɵfac = function HotkeysDirective_Factory(t) { return new (t || HotkeysDirective)(ɵngcc0.ɵɵdirectiveInject(HotkeysService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
HotkeysDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HotkeysDirective, selectors: [["", "hotkeys", ""]], inputs: { hotkeysOptions: "hotkeysOptions", hotkeys: "hotkeys", hotkeysGroup: "hotkeysGroup", hotkeysDescription: "hotkeysDescription" }, outputs: { hotkey: "hotkey" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotkeysDirective, [{
        type: core.Directive,
        args: [{
                selector: '[hotkeys]'
            }]
    }], function () { return [{ type: HotkeysService }, { type: ɵngcc0.ElementRef }]; }, { hotkeysOptions: [{
            type: core.Input
        }], hotkey: [{
            type: core.Output
        }], hotkeys: [{
            type: core.Input
        }], hotkeysGroup: [{
            type: core.Input
        }], hotkeysDescription: [{
            type: core.Input
        }] }); })();
        return HotkeysDirective;
    }());

    var HotkeysHelpComponent = /** @class */ (function () {
        function HotkeysHelpComponent(hotkeysService) {
            this.hotkeysService = hotkeysService;
            this.title = 'Available Shortcuts';
            this.dimiss = new core.EventEmitter();
            this.hotkeys = this.hotkeysService.getShortcuts();
        }
        HotkeysHelpComponent.prototype.handleDismiss = function () {
            this.dimiss.next();
        };
        HotkeysHelpComponent.ctorParameters = function () { return [
            { type: HotkeysService }
        ]; };
        __decorate([
            core.Input()
        ], HotkeysHelpComponent.prototype, "title", void 0);
        __decorate([
            core.Output()
        ], HotkeysHelpComponent.prototype, "dimiss", void 0);
HotkeysHelpComponent.ɵfac = function HotkeysHelpComponent_Factory(t) { return new (t || HotkeysHelpComponent)(ɵngcc0.ɵɵdirectiveInject(HotkeysService)); };
HotkeysHelpComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HotkeysHelpComponent, selectors: [["ng-component"]], inputs: { title: "title" }, outputs: { dimiss: "dimiss" }, decls: 2, vars: 2, consts: [["class", "hotkeys-help-header", 4, "ngIf"], ["class", "hotkeys-table-help", "cellspacing", "0", "width", "100%", 4, "ngFor", "ngForOf"], [1, "hotkeys-help-header"], [1, "hotkeys-help-header-title"], [1, "hotkeys-help-header-dismiss-button", 3, "click"], ["cellspacing", "0", "width", "100%", 1, "hotkeys-table-help"], [4, "ngIf"], ["class", "hotkeys-table-help-shortcut", 4, "ngFor", "ngForOf"], ["colspan", "2", 1, "hotkeys-table-help-group"], [1, "hotkeys-table-help-shortcut"], ["width", "75%", 1, "hotkeys-table-help-shortcut-description"], ["width", "25%", 1, "hotkeys-table-help-shortcut-keys"], [3, "innerHTML"]], template: function HotkeysHelpComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HotkeysHelpComponent_div_0_Template, 5, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HotkeysHelpComponent_table_1_Template, 4, 2, "table", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hotkeys);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc2.NgForOf]; }, pipes: function () { return [HotkeysShortcutPipe]; }, styles: ["[_nghost-%COMP%]   table[_ngcontent-%COMP%]{border:1px solid #e1e4e8;border-collapse:collapse;width:100%;margin-bottom:1rem;color:#212529}[_nghost-%COMP%]   th[_ngcontent-%COMP%]{background-color:#f6f8fa;border-top-left-radius:2px;border-top-right-radius:2px;border:1px solid #d1d5da;font-weight:500;font-size:14px;padding:8px 16px;border-bottom:0;text-align:left}[_nghost-%COMP%]   td[_ngcontent-%COMP%]{padding:8px 16px;border-top:1px solid #dee2e6}[_nghost-%COMP%]   kbd[_ngcontent-%COMP%]{margin-right:6px;background-color:#fafbfc;border:1px solid #d1d5da;border-bottom-color:#c6cbd1;border-radius:3px;box-shadow:inset 0 -1px 0 #c6cbd1;color:#444d56;font-size:12px;padding:3px 5px}[_nghost-%COMP%]   .hotkeys-help-shortcut-keys[_ngcontent-%COMP%]{text-align:right}[_nghost-%COMP%]   .hotkeys-help-header[_ngcontent-%COMP%]{font-size:1.25em;margin-bottom:1.25em;display:flex;flex-direction:row;justify-content:space-between;align-items:center}[_nghost-%COMP%]   .hotkeys-help-header-title[_ngcontent-%COMP%]{line-height:1.5}[_nghost-%COMP%]   .hotkeys-help-header-dismiss-button[_ngcontent-%COMP%]{border:none;font-size:18px;color:#9e9e9e;cursor:pointer}[_nghost-%COMP%]   .hotkeys-help-header-dismiss-button[_ngcontent-%COMP%]:focus{outline:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotkeysHelpComponent, [{
        type: core.Component,
        args: [{
                template: "<div *ngIf=\"title\" class=\"hotkeys-help-header\">\n  <span class=\"hotkeys-help-header-title\">{{ title }}</span>\n  <button class=\"hotkeys-help-header-dismiss-button\" (click)=\"handleDismiss()\">&#10005;</button>\n</div>\n\n<table class=\"hotkeys-table-help\" cellspacing=\"0\" width=\"100%\" *ngFor=\"let hotkeyGroup of hotkeys\">\n  <thead *ngIf=\"hotkeyGroup.group\">\n    <tr>\n      <th class=\"hotkeys-table-help-group\" colspan=\"2\">{{ hotkeyGroup.group }}</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class=\"hotkeys-table-help-shortcut\" *ngFor=\"let hotkey of hotkeyGroup.hotkeys\">\n      <td class=\"hotkeys-table-help-shortcut-description\" width=\"75%\">{{ hotkey.description }}</td>\n      <td class=\"hotkeys-table-help-shortcut-keys\" width=\"25%\">\n        <kbd [innerHTML]=\"hotkey.keys | hotkeysShortcut\"></kbd>\n      </td>\n    </tr>\n  </tbody>\n</table>\n",
                styles: [":host table{border:1px solid #e1e4e8;border-collapse:collapse;width:100%;margin-bottom:1rem;color:#212529}:host th{background-color:#f6f8fa;border-top-left-radius:2px;border-top-right-radius:2px;border:1px solid #d1d5da;font-weight:500;font-size:14px;padding:8px 16px;border-bottom:0;text-align:left}:host td{padding:8px 16px;border-top:1px solid #dee2e6}:host kbd{margin-right:6px;background-color:#fafbfc;border:1px solid #d1d5da;border-bottom-color:#c6cbd1;border-radius:3px;box-shadow:inset 0 -1px 0 #c6cbd1;color:#444d56;font-size:12px;padding:3px 5px}:host .hotkeys-help-shortcut-keys{text-align:right}:host .hotkeys-help-header{font-size:1.25em;margin-bottom:1.25em;display:flex;flex-direction:row;justify-content:space-between;align-items:center}:host .hotkeys-help-header-title{line-height:1.5}:host .hotkeys-help-header-dismiss-button{border:none;font-size:18px;color:#9e9e9e;cursor:pointer}:host .hotkeys-help-header-dismiss-button:focus{outline:0}"]
            }]
    }], function () { return [{ type: HotkeysService }]; }, { title: [{
            type: core.Input
        }], dimiss: [{
            type: core.Output
        }] }); })();
        return HotkeysHelpComponent;
    }());

    var symbols = {
        shift: '&#8679;',
        backspace: '&#9003;',
        tab: '&#8677;',
        space: '&#9251;',
        left: '&#8592;',
        right: '&#8594;',
        up: '&#8593;',
        down: '&#8595;',
        enter: '&#8996;'
    };
    var appleSymbols = {
        meta: '&#8984;',
        altleft: '&#8997;',
        control: '&#8963;',
        escape: '&#9099;'
    };
    var pcSymbols = {
        control: 'Ctrl',
        altleft: 'Alt',
        escape: 'Esc'
    };
    var HotkeysShortcutPipe = /** @class */ (function () {
        function HotkeysShortcutPipe() {
            var platform = hostPlatform();
            this.symbols = this.getPlatformSymbols(platform);
        }
        HotkeysShortcutPipe.prototype.transform = function (value, separator) {
            var _this = this;
            if (separator === void 0) { separator = ' + '; }
            if (!value) {
                return '';
            }
            return value
                .split('.')
                .map(function (c) { return c.toLowerCase(); })
                .map(function (c) { return _this.symbols[c] || c; })
                .join(separator);
        };
        HotkeysShortcutPipe.prototype.getPlatformSymbols = function (platform) {
            return platform === 'apple' ? __assign(__assign({}, symbols), appleSymbols) : __assign(__assign({}, symbols), pcSymbols);
        };
HotkeysShortcutPipe.ɵfac = function HotkeysShortcutPipe_Factory(t) { return new (t || HotkeysShortcutPipe)(); };
HotkeysShortcutPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "hotkeysShortcut", type: HotkeysShortcutPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotkeysShortcutPipe, [{
        type: core.Pipe,
        args: [{
                name: 'hotkeysShortcut'
            }]
    }], function () { return []; }, null); })();
        return HotkeysShortcutPipe;
    }());

    var HotkeysModule = /** @class */ (function () {
        function HotkeysModule() {
        }
HotkeysModule.ɵfac = function HotkeysModule_Factory(t) { return new (t || HotkeysModule)(); };
HotkeysModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HotkeysModule });
HotkeysModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[common.CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotkeysModule, [{
        type: core.NgModule,
        args: [{
                declarations: [HotkeysDirective, HotkeysHelpComponent, HotkeysShortcutPipe],
                entryComponents: [HotkeysHelpComponent],
                imports: [common.CommonModule],
                exports: [HotkeysDirective, HotkeysHelpComponent, HotkeysShortcutPipe]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HotkeysModule, { declarations: [HotkeysDirective, HotkeysHelpComponent, HotkeysShortcutPipe], imports: [ɵngcc2.CommonModule], exports: [HotkeysDirective, HotkeysHelpComponent, HotkeysShortcutPipe] }); })();
        return HotkeysModule;
    }());

    exports.HotkeysDirective = HotkeysDirective;
    exports.HotkeysHelpComponent = HotkeysHelpComponent;
    exports.HotkeysModule = HotkeysModule;
    exports.HotkeysService = HotkeysService;
    exports.HotkeysShortcutPipe = HotkeysShortcutPipe;

    Object.defineProperty(exports, '__esModule', { value: true });

})));

//# sourceMappingURL=ngneat-hotkeys.umd.js.map